import { render, staticRenderFns } from "./LandingModal.vue?vue&type=template&id=a0f56498&scoped=true&"
import script from "./LandingModal.vue?vue&type=script&lang=js&"
export * from "./LandingModal.vue?vue&type=script&lang=js&"
import style0 from "./LandingModal.vue?vue&type=style&index=0&id=a0f56498&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f56498",
  null
  
)

export default component.exports